import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const VerifyEmail = loadable(() => pMinDelay(import('./VerifyEmail'), 300), {
  fallback: <Loading />
});

const AsyncVerifyEmail = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <VerifyEmail { ...props }/>
    </ApplicationLayout>
  );
};

AsyncVerifyEmail.propTypes = {
  userAgent: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default AsyncVerifyEmail;
